import React, { useState } from "react";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import logo from "../assets/images/logo/Header-logo.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  // ===== COLOR THEME =====
 const COLORS = {
  bgPrimary: "#0B1C2D",      // Deep Navy Blue
  bgSecondary: "#13293D",
  gold: "#C6A75E",           // Elegant Gold
  goldDark: "#A8893D",
  white: "#FFFFFF",
  textLight: "#EAEAEA",
  borderLight: "rgba(255,255,255,0.1)",
};

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about-us" },
    {
      name: "Practice Areas",
      isDropdown: true,
      subLinks: [
        { name: "Civil Cases", href: "/services/civil-cases" },
        { name: "Criminal Cases", href: "/services/criminal-cases" },
        { name: "Matrimonial Cases", href: "/services/matrimonial-Cases" },
        { name: "Domestic Violence", href: "/services/domestic-violence" },
        { name: "Divorce Cases", href: "/services/divorce-cases" },
        { name: "Recovery of Money", href: "/services/recovery-of-money" },
        { name: "Partnership Matter", href: "/services/partnership-matters" },
        { name: "Property Disputes", href: "/services/property-disputes" },
        { name: "Negotiable Instrument Act Cases", href: "/services/negotiable-instrument-act-cases" },
        { name: "Environmental Matters", href: "/services/environmental-matters" },
        { name: "Bail Trial", href: "/services/bail-trial" },
        { name: "Company Related Issue", href: "/services/company-related-issue" },
        { name: "Cyber Cases", href: "/services/cyber-cases" },
      ],
    },
    { name: "Blog", href: "/blogs" },
    { name: "Contact Us", href: "/contact-us" },
  ];

  return (
    <header
      className="font-serif shadow-md fixed top-0 left-0 w-full z-50"
      style={{ backgroundColor: COLORS.bgPrimary, color: COLORS.white }}
    >
      <div className="max-w-7xl mx-auto w-full px-6 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        <div className="flex items-center justify-between py-3">

          {/* Logo */}
          <div className="flex items-center gap-8 xl:gap-10">
            <img
              src={logo}
              alt="Nyaysakti Logo"
              className="h-10 md:h-12 lg:h-14 w-auto object-contain cursor-pointer"
            />

            {/* Desktop Navigation */}
            <nav className="hidden xl:flex items-center space-x-6">
              {navLinks.map((link) => (
                <div
                  key={link.name}
                  className="relative"
                  onMouseEnter={() => link.isDropdown && setIsDropdownOpen(true)}
                  onMouseLeave={() => link.isDropdown && setIsDropdownOpen(false)}
                >
                  {link.isDropdown ? (
                    <button
                      type="button"
                      className="flex items-center gap-1 uppercase font-medium tracking-wide py-4 transition-colors duration-300"
                      onMouseOver={(e) => (e.target.style.color = COLORS.gold)}
                      onMouseOut={(e) => (e.target.style.color = COLORS.white)}
                    >
                      {link.name}
                      <FaChevronDown
                        size={12}
                        className={`transition-transform duration-300 ${
                          isDropdownOpen ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  ) : (
                    <a
                      href={link.href}
                      className="uppercase font-medium tracking-wide py-4 transition-colors duration-300"
                      onMouseOver={(e) => (e.target.style.color = COLORS.gold)}
                      onMouseOut={(e) => (e.target.style.color = COLORS.white)}
                    >
                      {link.name}
                    </a>
                  )}

                  {/* Dropdown */}
                  {link.isDropdown && isDropdownOpen && (
                    <div
                      className="absolute top-full left-0 w-64 shadow-xl py-4 flex flex-col"
                      style={{
                        backgroundColor: COLORS.bgPrimary,
                        borderTop: `2px solid ${COLORS.gold}`,
                      }}
                    >
                      {link.subLinks.map((sub) => (
                        <a
                          key={sub.name}
                          href={sub.href}
                          className="px-6 py-2 text-sm transition-all"
                          onMouseOver={(e) => {
                            e.target.style.color = COLORS.gold;
                            e.target.style.backgroundColor =
                              "rgba(212,163,115,0.1)";
                          }}
                          onMouseOut={(e) => {
                            e.target.style.color = COLORS.white;
                            e.target.style.backgroundColor = "transparent";
                          }}
                        >
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              {/* CTA Button */}
              <a
                href="/contact-us"
                className="ml-2 px-5 py-2 font-bold uppercase tracking-wider rounded transition-all duration-300"
                style={{
                  backgroundColor: COLORS.gold,
                  color: COLORS.bgPrimary,
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = COLORS.goldDark)
                }
                onMouseOut={(e) =>
                  (e.target.style.backgroundColor = COLORS.gold)
                }
              >
                Consult Now
              </a>
            </nav>
          </div>

          {/* Hamburger */}
          <div className="xl:hidden">
            <button onClick={toggleMenu} className="focus:outline-none">
              {isOpen ? <FaTimes size={26} /> : <FaBars size={26} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div
          className="xl:hidden h-screen overflow-y-auto"
          style={{
            backgroundColor: COLORS.bgPrimary,
            borderTop: `1px solid ${COLORS.borderLight}`,
          }}
        >
          <div className="px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <div key={link.name}>
                <div className="flex justify-between items-center py-2 border-b border-white/5">
                  {link.isDropdown ? (
                    <button
                      type="button"
                      className="uppercase font-medium tracking-wide flex items-center gap-2"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      {link.name} <FaChevronDown size={14} />
                    </button>
                  ) : (
                    <a
                      href={link.href}
                      className="uppercase font-medium tracking-wide"
                    >
                      {link.name}
                    </a>
                  )}
                </div>

                {link.isDropdown && isDropdownOpen && (
                  <div
                    className="pl-4 mt-2 space-y-3 py-3 rounded"
                    style={{ backgroundColor: COLORS.mobileSubBg }}
                  >
                    {link.subLinks.map((sub) => (
                      <a
                        key={sub.name}
                        href={sub.href}
                        className="block text-sm text-gray-300"
                      >
                        {sub.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}

            <a
              href="/contact-us"
              className="block w-full text-center px-6 py-3 font-bold uppercase tracking-wider rounded"
              style={{
                backgroundColor: COLORS.gold,
                color: COLORS.bgPrimary,
              }}
            >
              Consult Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;